import cloneDeep from 'lodash/cloneDeep'
import api from '@/api'
import c from '@/config'
import moment from 'moment'

const state = {
  // label
  drawType: 'positive_default',
  labelList: [],
  selectedLabel: null,
  frameRange: c.defaultFrameRange,
  labelComment: '',

  clothAssessment: {},

  selectedHistoryIdx: -1,
  historys: [],

  reviewComment: '',
  bestLabeling: false,
}
const getters = {
  isFrameInRange(state, getters, rootState) {
    return (
      rootState.frameIdx >= state.frameRange[0] &&
      rootState.frameIdx <= state.frameRange[1]
    )
  },
  historys(state) {
    return state.historys.map(history => {
      const labelInfo = history
      const reviewStatusMap = {
        Pending: '等待审核',
        Passed: '审核通过',
        Rejected: '审核驳回',
      }
      let reviewTime = ''
      let labelTime = ''
      if (labelInfo.reviewTimeInt64) {
        reviewTime = moment(labelInfo.reviewTimeInt64, 'YYYYMMDDHHmmss').format(
          'YYYY-MM-DD HH:mm:ss',
        )
      }
      if (labelInfo.labelTimeInt64) {
        labelTime = moment(labelInfo.labelTimeInt64, 'YYYYMMDDHHmmss').format(
          'YYYY-MM-DD HH:mm:ss',
        )
      }
      return {
        ...history,
        bestLabelingLabel: labelInfo.bestLabeling ? '是' : '否',
        labelTime,
        reviewStatusLabel: reviewStatusMap[labelInfo.reviewStatus],
        reviewTime,
      }
    })
  },
  labelList(state, getters, rootState) {
    let labelList = state.labelList
    if (
      state.selectedLabel !== null &&
      state.selectedLabel >= 0 &&
      state.selectedLabel < labelList.length
    ) {
      labelList = cloneDeep(state.labelList)
      labelList[state.selectedLabel].active = true
    }
    return labelList.filter(
      label =>
        rootState.frameIdx >= label.frameRange[0] &&
        rootState.frameIdx <= label.frameRange[1],
    )
  },
  labelInfo(state) {
    if (state.selectedHistoryIdx < 0) return { clothAssessment: {} }
    return state.historys[state.selectedHistoryIdx] || { clothAssessment: {} }
  },
  labelTable(state, getters) {
    const labelInfo = getters.labelInfo
    const reviewStatusMap = {
      Pending: '等待审核',
      Passed: '审核通过',
      Rejected: '审核驳回',
    }
    let reviewTime = ''
    let labelTime = ''
    if (labelInfo.reviewTimeInt64) {
      reviewTime = moment(labelInfo.reviewTimeInt64, 'YYYYMMDDHHmmss').format(
        'YYYY-MM-DD HH:mm:ss',
      )
    }
    if (labelInfo.labelTimeInt64) {
      labelTime = moment(labelInfo.labelTimeInt64, 'YYYYMMDDHHmmss').format(
        'YYYY-MM-DD HH:mm:ss',
      )
    }
    return [
      {
        bestLabeling: labelInfo.bestLabeling ? '是' : '否',
        detectionMachineId: labelInfo.detectionMachineId,
        factoryName: labelInfo.factoryName,
        labelComment: labelInfo.labelComment,
        labelTime,
        machineAlias: labelInfo.machineAlias,
        reviewComment: labelInfo.reviewComment,
        reviewStatus: reviewStatusMap[labelInfo.reviewStatus],
        reviewTime,
        reviewerName: labelInfo.reviewerName,
      },
    ]
  },
  labels(state, getters) {
    if (getters.labelInfo.labelData) {
      let labelData = []
      try {
        labelData = JSON.parse(getters.labelInfo.labelData)
      } catch (e) {
        console.log('getters.labelInfo.labelData is no a valid json string')
        return []
      }
      const labelList = labelData.map(label => {
        return {
          type: `${label.type}_${label.typeDetail}`,
          frameRange: [label.startIndex, label.endIndex],
          area: label.position,
        }
      })
      let statusLabelList = labelList
      if (
        state.selectedLabel !== null &&
        state.selectedLabel >= 0 &&
        state.selectedLabel < labelList.length
      ) {
        statusLabelList = cloneDeep(labelList)
        statusLabelList[state.selectedLabel].active = true
      }
      return statusLabelList
    }
    return []
  },
  diffClothAssessment(state, getters, rootState) {
    const result = {}
    if (Object.keys(getters.labelInfo.clothAssessment).length === 0) return {}
    rootState.clothAssessmentConfig &&
      Object.keys(rootState.clothAssessmentConfig).forEach(clothKey => {
        state.historys.forEach(history => {
          if (
            history.clothAssessment[clothKey] !==
            getters.labelInfo.clothAssessment[clothKey]
          ) {
            result[clothKey] = true
          }
        })
      })
    return result
  },
  curBaseLayer(state, getters, rootState) {
    const decodedVideo = rootState.decodedVideo
    if (decodedVideo.bufferArray.length > 0) {
      return {
        type: 'YUVBuffer',
        source: decodedVideo.bufferArray[rootState.frameIdx],
        width: decodedVideo.bufferWidth,
        height: decodedVideo.bufferHeight,
      }
    }
    return null
  },
  curLayerData(state, getters, rootState) {
    const result = []
    // Detected result
    // 由于解码时会固定丢失前面几帧非关键帧，decodedVideo 和 detectInfo 数量不总是一致的，因此需要将detectInfo向右平移，对齐图像
    const alignment = rootState.detectInfo.length - rootState.frameCount
    const detectInfoData = rootState.detectInfo[rootState.frameIdx + alignment]
    if (detectInfoData) {
      result.push({ type: 'DETECT_RESULT', data: detectInfoData })
    }
    // shield area
    const lineShield = rootState.shieldInfo.line
    if (lineShield) {
      result.push({ type: 'SHIELD_LINE', data: lineShield })
    }

    // manually shield
    let manuallyShieldData = null
    const manuallyShield = rootState.shieldInfo.manually
    if (manuallyShield && !(manuallyShield instanceof Array)) {
      manuallyShieldData = manuallyShield
    }
    result.push({ type: 'SHIELD_MANUALLY', data: manuallyShieldData })

    // label
    result.push({ type: 'LABEL', data: getters.labelList })
    return result
  },
  tools(state, getters, rootState) {
    const result = []
    if (rootState.showMagnifier) {
      result.push({ name: 'TOOL_MAGNIFIER', diameter: rootState.diameter })
    }
    if (getters.isFrameInRange) {
      result.push({ name: 'TOOL_DRAW', type: rootState.label.drawType })
    }
    return result
  },
}
const mutations = {
  setLabelList(state, labelList) {
    state.labelList = labelList
  },
  addLabel(state, label) {
    label.frameRange = state.frameRange
    state.labelList.push(label)
  },
  deleteLabelById(state, idx) {
    state.labelList.splice(idx, 1)
  },
  setSelectedLabel(state, selectedLabel) {
    state.selectedLabel = selectedLabel
  },
  setLabelListFrameRange(state) {
    const frameRange = state.frameRange
    // force set all label frame range
    state.labelList = state.labelList.map(label => {
      label.frameRange = frameRange
      return label
    })
  },
  setLabelComment(state, labelComment) {
    state.labelComment = labelComment
  },
  setHistorys(state, historys) {
    state.historys = historys
  },

  setClothAssessment(state, clothAssessment) {
    state.clothAssessment = clothAssessment
  },

  setSelectedHistoryIdx(state, selectedHistoryIdx) {
    state.selectedHistoryIdx = selectedHistoryIdx
  },
}
const actions = {
  fetchHistoryList({ state, commit, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      api
        .getHistory({ tarId: rootState.tarId, cameraId: rootGetters.cameraId })
        .then(({ data }) => {
          if (data.reviews) {
            commit(
              'setHistorys',
              data.reviews.sort(
                (a, b) => b.reviewTimeInt64 - a.reviewTimeInt64,
              ),
            )
            commit('setSelectedHistoryIdx', 0)
          } else {
            commit('setHistorys', [])
            commit('setSelectedHistoryIdx', 0)
          }
          resolve()
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
